import { apiClient } from '../apiClients';
import { Endpoints } from '../../network';

export const claimReward = async (product_id: string): Promise<any> => {
  const response = await apiClient.post(`${Endpoints.claimReward}`, {
    product_id,
    payment_type: 'wallet',
  });
  return response?.data;
};

export const getTransitionHistory = async ({
  type,
  page = 1,
  perPage = 10,
}: {
  type?: string;
  page: number;
  perPage: number;
}): Promise<any> => {
  const queryParams = new URLSearchParams({
    ...(type && { type }),
    page: page.toString(),
    per_page: perPage.toString(),
  });

  const response = await apiClient.get(
    `${Endpoints.walletTransactions}?${queryParams}`,
  );
  return response?.data;
};

export const inviteFriend = async ({
  email,
  name,
}: {
  email: string;
  name: string;
}): Promise<any> => {
  const response = await apiClient.post(`${Endpoints.inviteFriend}`, {
    email,
    name,
  });
  return response?.data;
};

export const getInviteFriend = async (): Promise<any> => {
  const response = await apiClient.get(`${Endpoints.inviteFriend}`);
  return response?.data;
};

export const getRewardRulesByName = async (name: string): Promise<any> => {
  const response = await apiClient.get(`${Endpoints.getRewardRule}/${name}`);
  return response?.data;
};

export const getInvitedUser = async (): Promise<any> => {
  const response = await apiClient.get(`${Endpoints.invitedUser}`);
  return response?.data;
};

export const getAllRewards = async ({
  start_date,
  end_date,
}: {
  start_date?: string;
  end_date?: string;
}): Promise<any> => {
  const queryParams = new URLSearchParams({
    ...(start_date && { start_date }),
    ...(end_date && { end_date }),
  });

  const response = await apiClient.get(
    `${Endpoints.getAllRewards}?${queryParams}`,
  );
  return response.data;
};

export const claimRewardDynamic = async (id: string): Promise<any> => {
  const response = await apiClient.get(`${Endpoints.claimRewardDynamic}/${id}`);
  return response.data;
};
